// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentChannelViewDetailsSkeleton-Header_cls1__11cjF","cls2":"PaymentChannelViewDetailsSkeleton-Header_cls2__ML5Ei PaymentChannelViewDetailsSkeleton-Header_cls1__11cjF"};